// extracted by mini-css-extract-plugin
export default {"item":"_1aJN7"};